module.exports = __webpack_public_path__ + "static/media/spending-hard-to-control.381db2ea.png";